/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Brouillon
 * 1 = Envoye
 * 2 = Valide
 * 3 = Prepare
 * 4 = Livre
 */
export enum CommandeStatut {
  Brouillon = 0,
  Envoye = 1,
  Valide = 2,
  Prepare = 3,
  Livre = 4
}
